import { render, staticRenderFns } from "./add-bill.vue?vue&type=template&id=2d0f6a4a&scoped=true&"
import script from "./add-bill.vue?vue&type=script&lang=js&"
export * from "./add-bill.vue?vue&type=script&lang=js&"
import style0 from "./add-bill.vue?vue&type=style&index=0&id=2d0f6a4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0f6a4a",
  null
  
)

export default component.exports